import {
  EyeFilled,
  ShoppingOutlined,
  CalendarOutlined,
  FileTextOutlined,
  TagOutlined,
  BgColorsOutlined,
} from '@ant-design/icons';
import { AButton, AModal } from '../../../components';
import { IInventoryOutput } from '../../../shared/interfaces';
import { formatDate } from '../../../shared/utils/format-date';
import {
  Card,
  Space,
  Statistic,
  Row,
  Col,
  Tag,
  Typography,
  Divider,
  Badge,
} from 'antd';

const { Text } = Typography;

interface IInventoryOutputViewProps {
  open: boolean;
  close: () => void;
  output: IInventoryOutput | null;
}

const getTypeColor = (type: string | undefined) => {
  if (type === 'treatment') return 'blue';
  if (type === 'dental_treatment') return 'green';
  return 'default';
};

const getTypeLabel = (type: string | undefined) => {
  if (type === 'treatment') return 'Tratamento';
  if (type === 'dental_treatment') return 'Odontologia';
  return 'Desconhecido';
};

const InventoryOutputView: React.FC<IInventoryOutputViewProps> = ({
  open,
  close,
  output,
}) => {
  return (
    <AModal
      open={open}
      close={close}
      title={
        <>
          <EyeFilled style={{ color: '#1677ff', fontSize: 20 }} /> Detalhes da
          Saída
        </>
      }
      footer={<AButton onClick={close}>Fechar</AButton>}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Card
          type="inner"
          title={
            <Space>
              <CalendarOutlined style={{ color: '#1890ff' }} />
              <span>Data</span>
            </Space>
          }
        >
          <Text>{formatDate(output?.date)}</Text>
        </Card>

        <Card
          type="inner"
          title={
            <Space>
              <ShoppingOutlined style={{ color: '#52c41a' }} />
              <span>Produto</span>
            </Space>
          }
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            <Text strong style={{ fontSize: 16 }}>
              {output?.product_name}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              ID do Produto: {output?.product_id}
            </Text>
          </Space>
        </Card>

        {output?.treatment_code && (
          <Card
            type="inner"
            title={
              <Space>
                <TagOutlined style={{ color: '#faad14' }} />
                <span>Tratamento Associado</span>
              </Space>
            }
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text strong>Código do Tratamento:</Text>
                </Col>
                <Col>
                  <Badge
                    count={output?.treatment_code}
                    style={{
                      backgroundColor: '#1890ff',
                      fontSize: 12,
                      height: 24,
                      lineHeight: '24px',
                    }}
                  />
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text strong>Tipo:</Text>
                </Col>
                <Col>
                  <Tag color={getTypeColor(output?.type)}>
                    {getTypeLabel(output?.type)}
                  </Tag>
                </Col>
              </Row>
            </Space>
          </Card>
        )}

        <Card
          type="inner"
          title={
            <Space>
              <BgColorsOutlined style={{ color: '#eb2f96' }} />
              <span>Quantidade</span>
            </Space>
          }
        >
          <Statistic
            value={output?.quantity || 0}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
        {output?.observation && (
          <Card
            type="inner"
            title={
              <Space>
                <FileTextOutlined style={{ color: '#13c2c2' }} />
                <span>Observação</span>
              </Space>
            }
          >
            <Text>{output?.observation}</Text>
          </Card>
        )}

        <Divider />
        <Card type="inner" size="small" style={{ background: '#fafafa' }}>
          <Space direction="vertical" style={{ fontSize: 12, width: '100%' }}>
            <Text type="secondary">Criado em: {formatDate(output?.date)}</Text>
          </Space>
        </Card>
      </Space>
    </AModal>
  );
};

export default InventoryOutputView;
